export function getPostboxDocumentsEndpoint(): string {
    return '/postbox-documents';
}

export function getPostboxContractDocumentsEndpoint(contractId?: string): string {
    return contractId ? `/postbox-documents/${contractId}` : '/postbox-documents';
}

export function getDocumentDownloadEndpoint(fileId: string, categoryCode: string): string {
    return `/postbox-documents/download/${fileId}/${categoryCode}`;
}
